import {
    Drawer,
    Box,
    Typography,
    IconButton,
    TextField,
  } from "@mui/material";
  import CloseIcon from "@mui/icons-material/Close";
  
  const ShowUser = ({ open, handleClose, userData }) => {
    
    return (
      <Drawer anchor="right" open={open} onClose={handleClose}>
        <Box sx={{ width: 600, p: 3 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6">Détails de l'utilisateur</Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
  
          <Box>
            <TextField
              fullWidth
              margin="normal"
              label="Prénom"
              value={userData?.usrFirstname || ""}
              InputProps={{
                readOnly: true, 
              }}
              variant="outlined"
            />
            <TextField
              fullWidth
              margin="normal"
              label="Nom"
              value={userData?.usrLastname || ""}
              InputProps={{
                readOnly: true,
              }}
              variant="outlined"
            />
            <TextField
              fullWidth
              margin="normal"
              label="Email"
              value={userData?.email || ""}
              InputProps={{
                readOnly: true,
              }}
              variant="outlined"
            />
          </Box>
        </Box>
      </Drawer>
    );
  };
  export default ShowUser;